import { profile } from "console";
import { ApiResult } from "../models/ApiResult";
import { ConfigurationEmployeeAppDTO, ConfigurationTimeStampDTO, EmployeeAppConfig, PayrollConfigurationDTO, TimeStampCalculationConfig, WorkSafetyConfigurationDTO } from "../models/Configuration";
import { ApplicationTypeDTO } from "../models/Profile";
import { TimeClockPauseConfigurationDTO, TimeStampCalculatedDTO } from "../models/TimeStamp";
import { IApiCrudRequest, IUrlAction } from "./interfaces";
import { ApiCrudRequest, apiMethode, ApiRESTRequest } from "./makeRequest";



const url: IUrlAction = {
    Get: "Configuration",
    other: {
        timestampCalculation: "TimeStampCalculation"
    }
}

const config: IApiCrudRequest = {
    url: url
}

class ConfigurationRequest extends ApiRESTRequest<ConfigurationTimeStampDTO> {
    constructor(config: IApiCrudRequest, token: string | undefined) {
        super(config, token);
    }

    GetTimeStampCalculation(): Promise<ConfigurationTimeStampDTO> {
        let url = this.CombinePath(['TimeStampCalculation'])
        return this.makeRequest<ConfigurationTimeStampDTO>(url, apiMethode.GET, null);
    }

    StoreTimeStampCalculation(data: ConfigurationTimeStampDTO): Promise<ApiResult> {
        let url = this.CombinePath(['TimeStampCalculation'])
        return this.makeRequest<ApiResult>(url, apiMethode.POST, data);
    }

    // per-profile override overlay (null field = inherit)
    GetTimeStampCalculationProfile(profileId: number): Promise<ConfigurationTimeStampDTO> {
        let url = this.CombinePath(['TimeStampCalculation', profileId.toString()])
        return this.makeRequest<ConfigurationTimeStampDTO>(url, apiMethode.GET, null);
    }

    StoreTimeStampCalculationProfile(data: ConfigurationTimeStampDTO, profileId: number): Promise<ApiResult> {
        let url = this.CombinePath(['TimeStampCalculation', profileId.toString()])
        return this.makeRequest<ApiResult>(url, apiMethode.POST, data);
    }

    // effective (merged global + profile override) timestamp calculation config for a profile
    GetTimeStampCalculationMerged(profileId: number): Promise<TimeStampCalculationConfig> {
        let url = this.CombinePath(['TimeStampCalculation', profileId.toString(), 'merged'])
        return this.makeRequest<TimeStampCalculationConfig>(url, apiMethode.GET, null);
    }

    // effective (merged) global config — what a profile inherits when it does not override a field
    GetTimeStampCalculationMergedGlobal(): Promise<TimeStampCalculationConfig> {
        let url = this.CombinePath(['TimeStampCalculation', 'merged'])
        return this.makeRequest<TimeStampCalculationConfig>(url, apiMethode.GET, null);
    }

    GetEmployeeApp(): Promise<ConfigurationEmployeeAppDTO> {
        let url = this.CombinePath(['EmployeeAppCalculation'])
        return this.makeRequest<ConfigurationEmployeeAppDTO>(url, apiMethode.GET, null);
    }

    StoreEmployeeApp(data: ConfigurationEmployeeAppDTO): Promise<ApiResult> {
        let url = this.CombinePath(['EmployeeAppCalculation'])
        return this.makeRequest<ApiResult>(url, apiMethode.POST, data);
    }

    GetEmployeeAppProfile(profileId: number): Promise<ConfigurationEmployeeAppDTO> {
        let url = this.CombinePath(['EmployeeAppCalculation', profileId.toString()])
        return this.makeRequest<ConfigurationEmployeeAppDTO>(url, apiMethode.GET, null);
    }

    StoreEmployeeAppProfile(data: ConfigurationEmployeeAppDTO, profileId: number): Promise<ApiResult> {
        let url = this.CombinePath(['EmployeeAppCalculation', profileId.toString()])
        return this.makeRequest<ApiResult>(url, apiMethode.POST, data);
    }

    // effective (merged global + profile override) config the employee app actually receives
    GetEmployeeAppMerged(profileId: number): Promise<EmployeeAppConfig> {
        let url = this.CombinePath(['EmployeeAppCalculation', profileId.toString(), 'merged'])
        return this.makeRequest<EmployeeAppConfig>(url, apiMethode.GET, null);
    }

    // effective (merged) global config — what a profile inherits when it does not override a field
    GetEmployeeAppMergedGlobal(): Promise<EmployeeAppConfig> {
        let url = this.CombinePath(['EmployeeAppCalculation', 'merged'])
        return this.makeRequest<EmployeeAppConfig>(url, apiMethode.GET, null);
    }

    // work safety
    GetWorkSafety(): Promise<WorkSafetyConfigurationDTO> {
        let url = this.CombinePath(['WorkSafety'])
        return this.makeRequest<WorkSafetyConfigurationDTO>(url, apiMethode.GET, null);
    }
    StoreWorkSafety(data: WorkSafetyConfigurationDTO): Promise<ApiResult> {
        let url = this.CombinePath(['WorkSafety'])
        return this.makeRequest<ApiResult>(url, apiMethode.POST, data);
    }

    // time clock pause
    GetTimeClockPause(): Promise<TimeClockPauseConfigurationDTO> {
        let url = this.CombinePath(['TimeClockPause'])
        return this.makeRequest<TimeClockPauseConfigurationDTO>(url, apiMethode.GET, null);
    }
    GetTimeClockPausePerProfileId(profileId: number): Promise<TimeClockPauseConfigurationDTO> {
        let url = this.CombinePath(['TimeClockPause', profileId.toString()])
        return this.makeRequest<TimeClockPauseConfigurationDTO>(url, apiMethode.GET, null);
    }
    StoreTimeClockPause(data: TimeClockPauseConfigurationDTO): Promise<ApiResult> {
        let url = this.CombinePath(['TimeClockPause'])
        return this.makeRequest<ApiResult>(url, apiMethode.POST, data);
    }
    StoreTimeClockPausePerProfileId(data: TimeClockPauseConfigurationDTO, profileId: number): Promise<ApiResult> {
        let url = this.CombinePath(['TimeClockPause', profileId.toString()])
        return this.makeRequest<ApiResult>(url, apiMethode.POST, data);
    }

    // payroll office
    GetPayrollOffice(): Promise<PayrollConfigurationDTO> {
        let url = this.CombinePath(['payrolloffice'])
        return this.makeRequest<PayrollConfigurationDTO>(url, apiMethode.GET, null);
    }
    StorePayrollOffice(data: PayrollConfigurationDTO): Promise<ApiResult> {
        let url = this.CombinePath(['payrolloffice'])
        return this.makeRequest<ApiResult>(url, apiMethode.POST, data);
    }
    GetPayrollOfficeConfigParams(): Promise<string[]> {
        let url = this.CombinePath(['payrolloffice', 'ConfigParams'])
        return this.makeRequest<string[]>(url, apiMethode.GET, null);
    }


}

const configurationRequest = (token: string | undefined) => new ConfigurationRequest(config, token);
export default configurationRequest;